/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    decorative: {
      description: 'Use a decorative divider to highlight an element. Non-decorative dividers are for clearly identifying separation of content.',
      type: 'variant',
      values: [ true ]
    },
    inverse: { type: 'variant', values: [ true ] },
    weight: { type: 'variant', values: [ 'thick' ] }
  },
  rules: [
    { if: { weight: 'thick' }, tokens: { width: 2 } },
    { if: { decorative: true }, tokens: { color: '#000000' } },
    {
      if: { decorative: true, weight: 'thick' },
      tokens: { color: '#000000', width: 2 }
    },
    { if: { inverse: true }, tokens: { color: '#ffffff' } },
    {
      if: { inverse: true, weight: 'thick' },
      tokens: { color: '#ffffff', width: 2 }
    }
  ],
  tokens: { color: '#c9c8c8', width: 1 }
}
export default theme
